'use client';

import React from 'react';
import { HeaderClient } from '@/components/ui/HeaderClient';
import { FooterClient } from '@/components/ui/FooterClient';
import ArticlesList from '@/components/sections/ArticlesList';
import { Button } from '@/components/ui/Button';

export default function Artigos() {
  return (
    <div className="min-h-screen flex flex-col items-center">
      <HeaderClient />

      <main className="flex flex-col flex-1 items-center w-full bg-[#FFFBF5]">
        <div className="flex flex-col w-full bg-[#FFFBF5] px-5 py-5 lg:py-10 lg:px-20 lg:max-w-7xl">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-secondary text-2xl sm:text-4xl font-medium mb-0 text-left">Artigos</h1>
            <Button component="a" variant="outline" size="xs" href="/">Voltar</Button>
          </div>

          <ArticlesList />
        </div>
      </main>
      
      <FooterClient />
    </div>
  );
}
